import { useState } from "react";
import { Button } from "@mui/material";
import { syncOzon } from "../../utils/syncClient";
import { useSnackbar } from "notistack";
import { COLORS } from "../../utils/colors";

export default function OzonSyncButton({ setReloadToken }) {
  const [syncLoading, setSyncLoading] = useState(false);

  const { enqueueSnackbar } = useSnackbar();
  return (
    <Button
      size="small"
      variant="contained"
      sx={{
        bgcolor: COLORS.OZON.bgcolor,
        color: COLORS.OZON.color,
      }}
      onClick={async () => {
        try {
          setSyncLoading(true);
          enqueueSnackbar("Заказы обновлены", { variant: "success" });
          await syncOzon();
          setReloadToken((x) => x + 1);
        } catch (e) {
          console.error("sync error", e);
          enqueueSnackbar("Синхронизация не удалась", { variant: "error" });
        } finally {
          setSyncLoading(false);
        }
      }}
      disabled={syncLoading}
    >
      {syncLoading ? "СИНХРОНИЗАЦИЯ…" : "ОБНОВИТЬ OZON"}
    </Button>
  );
}
